import React, { useEffect, useState } from 'react';
import { View, Text, Keyboard, TouchableWithoutFeedback, StyleSheet, BackHandler, Platform, Alert, StatusBar, TouchableOpacity, ScrollView, ImageBackground, TouchableHighlight, SafeAreaView, FlatList, ActivityIndicator } from 'react-native';
import Btn from "../components/btn"
import INPU from "../components/input"
import Colors from '../constants/Colors';
import { Ionicons, } from "@expo/vector-icons"
import { Image, Modal, NativeBaseProvider, useMediaQuery, } from 'native-base';
import { getListMdfColor, getMdfimage, getMdfWhite, SetEditForm, SetForm } from '../store/action/userProduct';
import { useDispatch, useSelector } from 'react-redux';
import AwesomeAlert from 'react-native-awesome-alerts';
import { useIsFocused } from '@react-navigation/native';
import { getProfileinfo, logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { GetTypeMdf } from '../store/action/finalproduct';
import INPUWEB from '../components/inputweb';









const Form = (props) => {
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [MDFWhite, setMDFWhite] = useState([]);
    const [MDFColor, setMDFColor] = useState([]);
    const [ERROR, setError] = useState(false);
    const [ERRORing, setERRORing] = useState(false);
    const [Massage, setMassage] = useState();
    const [IMAGING, setImage] = useState(props.route.params.orderid);
    const [task, setTask] = useState("");
    const [description, setdescription] = useState("ندارم");
    const [Width, setWidth] = useState("");
    const [Height, setHeight] = useState("");

    const [Width_mdf, setWidth_mdf] = useState("366");
    const [Height_mdf, setHeight_mdf] = useState("183");
    const [panel_description, setpanel_description] = useState("ندارم");

    const [width_one, setwidth_one] = useState("0");
    const [width_two, setwidth_two] = useState("0");
    const [length_one, setlength_one] = useState("0");
    const [length_two, setlength_two] = useState("0");
    const [up_rotation, setup_rotation] = useState(false);

    const [State, setState] = useState({
        showModal: false,
        showModal1: false,
        showModal2: false,
        isLoading: false,
        isLoading1: false,
        Active: props.route.params.Sliceid || props.route.params.orderid ? 1 : 0,
        Active1: "",
        white: props.route.params.white ? props.route.params.white : "",

        type_mdf: "نئوپان",
        type_mil: "3میل",


    })












    const [Forming, setForming] = useState({

        Radio1: props.route.params.color_strip ? props.route.params.color_strip : "color",
        Radio2: props.route.params.width_strip ? props.route.params.width_strip : "1",
        Radio3: props.route.params.height_strip ? props.route.params.height_strip : "single",

        imagemdf: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOVLVPLsjgkzqnuf8I9HWsn675o_uSnDF8uw&usqp=CAU",


    })




    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    const handleGetTypeMdf = async () => {


        try {
            if (Width_mdf == "" || Height_mdf == "" || Width_mdf < Height_mdf) {
                setERRORing(true)

            } else {
                const res = await dispatch(GetTypeMdf([State.type_mdf, State.type_mil, Width_mdf, Height_mdf, panel_description, Forming.Radio1, Forming.Radio2, Forming.Radio3, panel_description]));
                setState({ ...State, showModal: false, Active: 1 })
            }


        } catch (err) {
            console.log(err);
        }
    };




    const [counter, setCounter] = useState(1);
    const incrementCounter = () => setCounter(counter + 1);
    let decrementCounter = () => setCounter(counter - 1);

    if (counter <= 1) {
        decrementCounter = () => setCounter(1);
    }


    //   console.log(tokens);
    // console.log([
    //     props.route.params.orderid,
    //                  props.route.params.idgroup,

    // ]);
    const sendFORMHandler = async () => {
        try {

            setState({ ...State, isLoading1: true })
            const res = await dispatch(SetForm(tokens,
                props.route.params.orderid,
                props.route.params.idgroup,
                Height,
                Width,
                counter,
                up_rotation,
                width_one,
                width_two,
                length_one,
                length_two,
                description




            ));
            // console.log(res);

            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")

            } else if (res.status == "error") {
                setError(true)
                setMassage(res.message)
            }
            setState({ ...State, isLoading1: false })
        } catch (err) {
            // logOutHandler();
        }
    };



    const sendEDITFORMHandler = async () => {
        try {

            setState({ ...State, isLoading1: true })
            const res = await dispatch(SetEditForm(tokens,
                props.route.params.Sliceid,
                // Forming.idproduct,
                Height,
                Width,
                counter,
                up_rotation,
                width_one,
                width_two,
                length_one,
                length_two,
                description



            ));


            // console.log(res);

            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")


            } else if (res.status == "error") {
                setError(true)
                setMassage(res.message)
            }
            setState({ ...State, isLoading1: false })
        } catch (err) {
            // logOutHandler();
        }
    };






    const isfocuce = useIsFocused()
    useEffect(() => {
        if (props.route.params.Sliceid) {
            getMDFimageHandler();
        }


        getprofileHandler();
        getMDFWHITEHandler();
        getMDFCOLORandler();

        // if (!tokens) {
        //     logOutHandler()
        // }
    }, [isfocuce])

    const getMDFimageHandler = async () => {
        try {

            setState({ ...State, isLoading: true })
            const res = await dispatch(getMdfimage(tokens, props.route.params.Sliceid));
            setImage(res.data.data.slice.order_id)
            setCounter(JSON.parse(res.data.data.slice.count))
            setdescription(res.data.data.slice.description)
            setWidth(res.data.data.slice.width)
            setHeight(res.data.data.slice.height)
            setwidth_one(res.data.data.slice.width_one)
            setwidth_two(res.data.data.slice.width_two)
            setlength_one(res.data.data.slice.length_one)
            setlength_two(res.data.data.slice.length_two)
            setup_rotation(JSON.parse(res.data.data.slice.rotate_status))
            //console.log(res.data.data.slice.order_id);
            setState({ ...State, isLoading: false })


        } catch (err) {
            // logOutHandler();
        }
    };












    //گرفتن سفید
    const getMDFWHITEHandler = async () => {
        try {
            // setState({ ...State, isLoading: true })
            const res = await dispatch(getMdfWhite(tokens));
            setMDFWhite(res.data.data.products.data)
            // console.log(res.data.data.products.data);
            // setState({ ...State, isLoading: false })


        } catch (err) {
            console.log(err);
        }
    };

    //گزفتن رنگی
    const getMDFCOLORandler = async () => {
        try {
            //  setState({ ...State, isLoading1: true })
            const res = await dispatch(getListMdfColor(tokens));
            setMDFColor(res.data.data.saves.data)
            // console.log(res.data.data.saves.data);
            // setState({ ...State, isLoading1: false })


        } catch (err) {
            console.log(err);
        }
    };



    const getprofileHandler = async () => {
        try {

            const res = await dispatch(getProfileinfo(tokens));
            //console.log(res.data.data.user);
            setTask(res.data.data.user)


        } catch (err) {
            console.log(err);
        }
    }




    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });


    return !State.isLoading ? (

        <NativeBaseProvider>




            <View style={{
                width: isSmallScreen ? "100%" : 500,
                height: "100%",
                marginLeft:isSmallScreen?0:"35%",
                backgroundColor: Colors.background1,
                position: Platform.OS == "web" ? "fixed" : "relative"


            }}>


                <View style={styles.viewHeader}>
                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => {
                        if (props.route.params.orderid) {
                            props.navigation.navigate("list", {
                                ids: props.route.params.orderid
                            })
                        } else {
                            props.navigation.goBack()
                        }


                    }} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => {
                        if (props.route.params.orderid) {
                            props.navigation.navigate("list", {
                                ids: props.route.params.orderid
                            })
                        } else {
                            props.navigation.goBack()
                        }


                    }} style={styles.textheader}>
                        <Text style={styles.texttitle}>
                            انتخاب جزئیات تکه
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => setState({ ...State, showModal2: true })} style={{ width: 30, height: 30, position: "absolute", top: Platform.OS == "web" ? 20 : 35, left: 15, }}   >
                        <Ionicons name="alert-circle-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>
                </View>

                {/* توضیحات در صفحه  */}
                <Modal justifyContent="center" size="xl"
                    isOpen={State.showModal2} onClose={() => setState({ ...State, showModal2: false })}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >

                            <View style={{ width: "100%", height: 150 }}>
                                <View style={{ width: "100%", height: 50, }}>
                                    <Ionicons onPress={() => setState({ ...State, showModal2: false })} name="close" size={20} color={Colors.black} />
                                </View>

                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, }}>در این صفحه شما ابتدا باید نوع نوار و نوع ورق را مشخص کنید و بعد از آن مقادیر را انتخاب کنید.بانگه داشتن گزینه نوار هم میتوانید نوع نوار و نوع ورق را تغییر دهید.</Text>


                            </View>


                        </Modal.Body>

                    </Modal.Content>
                </Modal>



                {/* مدال ورق سفید و رنگی */}
                <Modal justifyContent="center" size="xl"
                    isOpen={State.showModal1} onClose={() => setState({ ...State, showModal1: false })}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >

                            <View style={{ width: "100%", height: 500 }}>
                                <View style={{ width: "100%", height: 50, }}>
                                    <Text style={styles.textmodal}>انتخاب نوع ورق</Text>

                                    <Ionicons onPress={() => setState({ ...State, showModal1: false })} name="close" size={20} color={Colors.black} />
                                </View>


                                <View style={{ flexDirection: "row", width: "90%", height: 50, marginBottom: 10, backgroundColor: Colors.secondText2, left: 20, marginTop: 10, borderRadius: 10, borderWidth: 1, borderColor: Colors.secondText3, alignItems: "center", justifyContent: "center", paddingRight: "3%", paddingLeft: "3%" }}>
                                    <TouchableOpacity onPress={() => {
                                        setState({ ...State, Active1: 1, white: false })
                                    }} style={{ justifyContent: "center", position: "absolute", left: "20%" }}>
                                        <Text style={{ fontFamily: State.Active1 == 1 ? "MontserratBold" : "Montserrat", fontSize: 18, color: State.Active1 == 1 ? Colors.primary : Colors.black }}>رنگی</Text>
                                        <View style={{ right: 5, width: "120%", height: 2, backgroundColor: State.Active1 == 1 ? Colors.primary : Colors.secondText2 }}></View>
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => {
                                        setState({ ...State, Active1: 2, white: true })
                                    }} style={{ justifyContent: "center", position: "absolute", right: "20%" }} >
                                        <Text style={{ fontFamily: State.Active1 == 2 ? "MontserratBold" : "Montserrat", fontSize: 18, color: State.Active1 == 2 ? Colors.primary : Colors.black }}>سفید</Text>
                                        <View style={{ right: 5, width: "120%", height: 2, backgroundColor: State.Active1 == 2 ? Colors.primary : Colors.secondText2 }}></View>
                                    </TouchableOpacity>
                                </View>


                                {State.Active1 == 2 ?
                                    <ScrollView>


                                        {MDFWhite.map((item, i) => {
                                            return (
                                                <TouchableOpacity onPress={() => {

                                                    setForming({ ...Forming, idproduct: item.id, imagemdf: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOVLVPLsjgkzqnuf8I9HWsn675o_uSnDF8uw&usqp=CAU" })
                                                    setState({ ...State, showModal1: false })
                                                }} key={i} style={styles.touch}>


                                                    <View style={{ width: "100%", height: 30, marginTop: 10, marginBottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}>
                                                            نوع ورق :

                                                            <Text style={styles.texttouch}> ورق سفید   </Text>
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: "100%", height: 30, marginBottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}>
                                                            نوع مغزی :

                                                            <Text style={styles.texttouch}> {item.core} </Text>
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: "100%", height: 30, marginBottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}>
                                                            ضخامت :

                                                            <Text style={styles.texttouch}> {item.width} میل </Text>
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: "100%", height: 30, marginBottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}>
                                                            ابعاد :

                                                            <Text style={styles.texttouch}> {item.dimension} </Text>
                                                        </Text>
                                                    </View>

                                                </TouchableOpacity>

                                            )
                                        })}
                                    </ScrollView>
                                    :
                                    <View></View>}



                                {State.Active1 == 1 ?
                                    <ScrollView>

                                        {MDFColor.map((item, i) => {
                                            return (
                                                <TouchableOpacity onPress={() => {

                                                    setForming({ ...Forming, idproduct: item.product_id, imagemdf: item.product.thumb })
                                                    setState({ ...State, showModal1: false })
                                                }} key={i} style={styles.touch}>


                                                    <View style={{ width: "100%", height: 30, marginTop: 10, marginBottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, marginRight: "3%" }}>
                                                            نوع ورق :

                                                            <Text style={styles.texttouch}> {item.product.title} </Text>
                                                        </Text>
                                                    </View>

                                                    <View style={{ width: "100%", height: 50, bottom: 10 }}>
                                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, marginRight: "3%" }}>
                                                            توضیحات :

                                                            <Text style={styles.texttouch}> {item.product.description} </Text>
                                                        </Text>
                                                    </View>
                                                    <View style={{ width: "99%", height: 90, bottom: 14, }}>
                                                        <Image source={{ uri: item.product.thumb ? item.product.thumb : "https://idts.ir/xtra/wp-content/uploads/2017/06/XP08-.-Noce-Virginia-02.jpg" }} alt="image" style={{ width: "100%", height: 90, borderRadius: 5 }} />

                                                    </View>

                                                </TouchableOpacity>
                                            )
                                        })}






                                    </ScrollView>
                                    :
                                    <View></View>}



                            </View>


                        </Modal.Body>

                    </Modal.Content>
                </Modal>



                {/* مدال فرم اول صفحه */}
                <Modal justifyContent="center" size="lg"
                    isOpen={State.showModal} onClose={() => setState({ ...State, showModal: false })}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >



                            <View style={{ width: "100%", height: 450 }}>

                                <ScrollView>

                                    <View style={{ width: "100%", height: 40, }}>
                                        <Text style={styles.textmodal}>انتخاب نوع نوار</Text>

                                        <Ionicons onPress={() => setState({ ...State, showModal: false })} name="close" size={20} color={Colors.black} />
                                    </View>



                                    <View style={{ width: "100%", height: 25, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}> رنگ نوار : </Text>
                                    </View>

                                    <View style={{ width: "100%", height: 40, flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                        <Ionicons onPress={() => setForming({ ...Forming, Radio1: "other" })} name={Forming.Radio1 == "color" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio1 == "color" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 70 }}>سایر  </Text>


                                        <Ionicons onPress={() => setForming({ ...Forming, Radio1: "color" })} name={Forming.Radio1 == "other" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio1 == "other" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, }}>همرنگ  </Text>
                                    </View>






                                    <View style={{ width: "100%", height: 25, marginTop: 10, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}> ضخامت : </Text>
                                    </View>


                                    <View style={{ width: "100%", height: 40, flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                                        <Ionicons onPress={() => setForming({ ...Forming, Radio2: "2" })} name={Forming.Radio2 == "1" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio2 == "1" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 65 }}>2 میل  </Text>


                                        <Ionicons onPress={() => setForming({ ...Forming, Radio2: "1" })} name={Forming.Radio2 == "2" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio2 == "2" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 8 }}>1 میل  </Text>
                                    </View>





                                    <View style={{ width: "100%", height: 25, marginTop: 10, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "3%" }}> ارتفاع : </Text>
                                    </View>




                                    <View style={{ width: "100%", height: 40, flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: 10 }}>
                                        <Ionicons onPress={() => setForming({ ...Forming, Radio3: "double" })} name={Forming.Radio3 == "single" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio3 == "single" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 68 }}>دوبل    </Text>


                                        <Ionicons onPress={() => setForming({ ...Forming, Radio3: "single" })} name={Forming.Radio3 == "double" ? "ellipse-outline" : 'checkmark-circle'}
                                            size={30} color={Forming.Radio3 == "double" ? Colors.secondText3 : Colors.yellowlight} />
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 12 }}>تک   </Text>
                                    </View>




                                    <View style={{ width: "100%", height: 40, }}>
                                        <Text style={styles.textmodal}>انتخاب نوع ورق :</Text>


                                    </View>







                                    <View style={{ width: "100%", height: 30, marginTop: 5, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}>نوع مغزی  : </Text>
                                    </View>


                                    <View style={{ width: "100%", alignSelf: "auto", flexDirection: "column", }}>
                                        <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "نئوپان" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>نئوپان</Text>
                                            <Ionicons name={State.type_mdf == "نئوپان" ? 'checkbox' : "square-outline"}
                                                size={25} color={State.type_mdf == "نئوپان" ? Colors.yellowlight : Colors.secondText3} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "ام دی اف", })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>ام دی اف</Text>
                                            <Ionicons name={State.type_mdf !== "ام دی اف" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mdf !== "ام دی اف" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "فومیزه" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>فومیزه</Text>
                                            <Ionicons name={State.type_mdf !== "فومیزه" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mdf !== "فومیزه" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "هایگلاس" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>هایگلاس</Text>
                                            <Ionicons name={State.type_mdf !== "هایگلاس" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mdf !== "هایگلاس" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "صفحه کابینت" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>صفحه کابینت</Text>
                                            <Ionicons name={State.type_mdf !== "صفحه کابینت" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mdf !== "صفحه کابینت" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                    </View>




                                    <View style={{ width: "100%", height: 30, marginTop: 10, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}> ضخامت ورق: </Text>
                                    </View>


                                    <View style={{ width: "100%", alignSelf: "auto", flexDirection: "column", }}>
                                        <TouchableOpacity onPress={() => setState({ ...State, type_mil: "3میل", })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>3 میل</Text>
                                            <Ionicons name={State.type_mil !== "3میل" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mil !== "3میل" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mil: "8میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>8 میل</Text>
                                            <Ionicons name={State.type_mil !== "8میل" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mil !== "8میل" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mil: "16میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>16 میل</Text>
                                            <Ionicons name={State.type_mil !== "16میل" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mil !== "16میل" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>

                                        <TouchableOpacity onPress={() => setState({ ...State, type_mil: "25میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>25 میل</Text>
                                            <Ionicons name={State.type_mil !== "25میل" ? "square-outline" : 'checkbox'}
                                                size={25} color={State.type_mil !== "25میل" ? Colors.secondText3 : Colors.yellowlight} />
                                        </TouchableOpacity>



                                    </View>



                                    <View style={{ width: "100%", height: 30, marginTop: 10, marginBottom: 10 }}>
                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}>ابعاد کلی ورق مصرفی: </Text>
                                    </View>



                                    <INPU
                                        label="طول ورق"
                                        styleview={{ marginTop: "3%", height: 70, }}
                                        stylelabel={{ width: "23%", backgroundColor: Colors.primary, }}
                                        value={Width_mdf}
                                        onChangeText={(text) => setWidth_mdf(text)}
                                        styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                        keyboardType="number-pad"

                                    />

                                    <INPU
                                        label="عرض ورق"
                                        styleview={{ marginTop: "3%", height: 70 }}
                                        stylelabel={{ width: "23%", backgroundColor: Colors.background }}
                                        value={Height_mdf}
                                        onChangeText={(text) => setHeight_mdf(text)}
                                        styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                        keyboardType="number-pad"

                                    />







                                </ScrollView>

                                <Btn
                                    touchableStyle={{
                                        width: "90%",
                                        height: 50,
                                        backgroundColor: Colors.primary,
                                    }}
                                    textStyle={{ bottom: 10, fontSize: 16 }}
                                    style={{ marginTop: 30, bottom: 10, left: 10 }}
                                    onPress={() => {
                                        handleGetTypeMdf()
                                    }}
                                    colorspin={Colors.background}
                                    sizespin={25}
                                    label="ثبت"

                                />





                            </View>


                            <AwesomeAlert

                                show={ERRORing}
                                showProgress={false}
                                title={"اخطار"}
                                message={"لطفا اطلاعات طول و عرض راکامل کنید.مقدار طول نباید از عرض بیشتر باشد."}
                                closeOnTouchOutside={false}
                                closeOnHardwareBackPress={false}

                                showConfirmButton={true}
                                confirmText="باشه"
                                confirmButtonColor={Colors.success}

                                onConfirmPressed={() => {
                                    setERRORing(false)
                                }}
                                titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                                messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                                confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                                confirmButtonStyle={{ width: "40%", height: 40, alignItems: "center" }}

                            />
                        </Modal.Body>

                    </Modal.Content>
                </Modal>



                <ScrollView>

                    {State.Active == 1 ?
                        <View></View>
                        :


                        //   <View style={{ flexDirection: "row", width: "80%", height: 40, marginTop: "10%", justifyContent: "center", paddingRight: 10, left: Platform.OS == "web" ? "10%" : "40%" }}>

                        //         <TouchableOpacity onPress={() => setState({ ...State, showModal: true })} style={{ backgroundColor: Colors.yellowlight, borderRadius: 10, width: "30%", height: 40, alignItems: "center", justifyContent: 'center', right: 120 }}>

                        //             <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.black, }}>نوع نوار</Text>
                        //         </TouchableOpacity>

                        //         <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.black, position: "absolute", top: Platform.OS == "web" ? 10 : 5, left: 110 }}>لطفا ابتدا نوع نوار و نوع ورق را مشخص کنید</Text>

                        //     </View>


                        <View style={{ width: "100%", }}>



                            <View style={{ width: "100%", height: 30, marginTop: 10 }}>
                                <Text style={styles.textmodal}>انتخاب نوع نوار</Text>
                            </View>



                            {/* <View style={{ width: "100%", height: 25, marginBottom: 10 }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}> رنگ نوار : </Text>
                            </View> */}

                            <View style={{ width: "100%", height: 35, flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }}>


                                <Ionicons onPress={() => setForming({ ...Forming, Radio1: "other" })} name={Forming.Radio1 == "color" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio1 == "color" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 100, marginRight: "16%" }}>سایر  </Text>


                                <Ionicons onPress={() => setForming({ ...Forming, Radio1: "color" })} name={Forming.Radio1 == "other" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio1 == "other" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: "8%" }}>همرنگ  </Text>


                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "9%" }}> رنگ نوار : </Text>
                            </View>






                            {/* <View style={{ width: "100%", height: 25, marginTop: 10, marginBottom: 10 }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}> ضخامت : </Text>
                            </View> */}


                            <View style={{ width: "100%", height: 35, flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }}>
                                <Ionicons onPress={() => setForming({ ...Forming, Radio2: "2" })} name={Forming.Radio2 == "1" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio2 == "1" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: "15%" }}>2 میل </Text>


                                <Ionicons onPress={() => setForming({ ...Forming, Radio2: "1" })} name={Forming.Radio2 == "2" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio2 == "2" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: "10%" }}>1 میل  </Text>

                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "9%" }}> ضخامت : </Text>

                            </View>






                            {/* <View style={{ width: "100%", height: 25, marginTop: 10, marginBottom: 10 }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}> ارتفاع : </Text>
                            </View> */}




                            <View style={{ width: "100%", height: 35, flexDirection: "row", justifyContent: "flex-end", alignItems: "center", marginBottom: 10 }}>
                                <Ionicons onPress={() => setForming({ ...Forming, Radio3: "double" })} name={Forming.Radio3 == "single" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio3 == "single" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: "15%" }}>دوبل  </Text>


                                <Ionicons onPress={() => setForming({ ...Forming, Radio3: "single" })} name={Forming.Radio3 == "double" ? "ellipse-outline" : 'checkmark-circle'}
                                    size={30} color={Forming.Radio3 == "double" ? Colors.secondText3 : Colors.yellowlight} />
                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, marginRight: 59 }}>تک   </Text>

                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "11%" }}>ارتفاع : </Text>
                            </View>




                            <View style={{ width: "100%", height: 30, }}>
                                <Text style={styles.textmodal}>انتخاب نوع ورق :</Text>


                            </View>







                            <View style={{ width: "100%", height: 30, marginTop: 5, marginBottom: 10, flexDirection: "row", justifyContent: "flex-end" }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "5%", marginRight: "30%" }}>ضخامت ورق : </Text>

                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}>نوع مغزی : </Text>
                            </View>

                            <View style={{ width: "100%", alignSelf: "auto", flexDirection: "row" }}>


                                {/* <View style={{ width: "100%", height: 30, marginTop: 10, marginBottom: 10 }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "5%" }}> ضخامت ورق: </Text>
                            </View> */}


                                <View style={{ width: "50%", alignSelf: "auto", flexDirection: "column", right: "5%" }}>
                                    <TouchableOpacity onPress={() => setState({ ...State, type_mil: "3میل", })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>3 میل</Text>
                                        <Ionicons name={State.type_mil !== "3میل" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mil !== "3میل" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mil: "8میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>8 میل</Text>
                                        <Ionicons name={State.type_mil !== "8میل" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mil !== "8میل" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mil: "16میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>16 میل</Text>
                                        <Ionicons name={State.type_mil !== "16میل" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mil !== "16میل" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mil: "25میل" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>25 میل</Text>
                                        <Ionicons name={State.type_mil !== "25میل" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mil !== "25میل" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>



                                </View>



                                <View style={{ width: "50%", alignSelf: "auto", flexDirection: "column", right: "8%" }}>
                                    <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "نئوپان" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>نئوپان</Text>
                                        <Ionicons name={State.type_mdf == "نئوپان" ? 'checkbox' : "square-outline"}
                                            size={25} color={State.type_mdf == "نئوپان" ? Colors.yellowlight : Colors.secondText3} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "ام دی اف", })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>ام دی اف</Text>
                                        <Ionicons name={State.type_mdf !== "ام دی اف" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mdf !== "ام دی اف" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "فومیزه" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>فومیزه</Text>
                                        <Ionicons name={State.type_mdf !== "فومیزه" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mdf !== "فومیزه" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "هایگلاس" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>هایگلاس</Text>
                                        <Ionicons name={State.type_mdf !== "هایگلاس" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mdf !== "هایگلاس" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>

                                    <TouchableOpacity onPress={() => setState({ ...State, type_mdf: "صفحه کابینت" })} style={{ width: "95%", height: 35, flexDirection: "row", justifyContent: "flex-end" }}>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, marginRight: "3%" }}>صفحه کابینت</Text>
                                        <Ionicons name={State.type_mdf !== "صفحه کابینت" ? "square-outline" : 'checkbox'}
                                            size={25} color={State.type_mdf !== "صفحه کابینت" ? Colors.secondText3 : Colors.yellowlight} />
                                    </TouchableOpacity>
                                </View>

                            </View>





                            <View style={{ width: "100%", height: 30, marginBottom: 10 }}>
                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.black, marginRight: "6%" }}>ابعاد کلی ورق مصرفی: </Text>
                            </View>
                            {Platform.OS == "web" ?
                                <View style={{ width: "100%", alignSelf: "auto", flexDirection: "row", justifyContent: "center", marginBottom: 10 }}>




                                    <INPUWEB
                                        style={{ width: "90%", marginTop: 5,marginLeft:-2 }}
                                        stylelabel={{ zIndex: 2, width: "18%", top: -4, marginLeft:isSmallScreen ? "-6%" :  "-5%"  }}
                                        label="عرض ورق"
                                        type="text"
                                        id="message"
                                        name="message"
                                        onChange={(event) => setHeight_mdf(event.target.value)}
                                        value={Height_mdf}

                                    />

                                    <INPUWEB
                                        style={{ width: "90%", marginTop: 5, }}
                                        stylelabel={{ zIndex: 2, width: "17%", top: -4, marginLeft:isSmallScreen ? "40%" :  "32%" }}
                                        label="طول ورق"
                                        type="text"
                                        id="message"
                                        name="message"
                                        onChange={(event) => setWidth_mdf(event.target.value)}
                                        value={Width_mdf}

                                    />






                                </View>
                                :
                                <View style={{ width: "100%", alignSelf: "auto", flexDirection: "row", justifyContent: "center", marginBottom: 10 }}>






                                    <INPU
                                        label="عرض ورق"
                                        styleview={{ width: "46%", marginTop: "3%", height: 70 }}
                                        stylelabel={{ width: "35%", backgroundColor: Colors.background }}
                                        value={Height_mdf}
                                        onChangeText={(text) => setHeight_mdf(text)}
                                        styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                        keyboardType="number-pad"

                                    />

                                    <INPU
                                        label="طول ورق"
                                        styleview={{ width: "46%", marginTop: "3%", height: 70 }}
                                        stylelabel={{ width: "35%", backgroundColor: Colors.background }}
                                        value={Width_mdf}
                                        onChangeText={(text) => setWidth_mdf(text)}
                                        styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                        keyboardType="number-pad"

                                    />





                                </View>
                            }
                            <INPU
                                label=" توضیحات ورق"
                                multiline
                                styleinput={{ height: 100,outlineColor: Colors.primary }}
                                styleview={{ height: 100, marginBottom: "5%", marginTop: 10 }}
                                stylelabel={{ width: 93, top: Platform.OS == "web" ? -10 : -15 }}
                                keyboardType="default"
                                value={panel_description}
                                onChangeText={(text) => setpanel_description(text)}


                            //styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                            />


                            <Btn
                                touchableStyle={{
                                    width: "90%",
                                    height: 50,
                                    backgroundColor: Colors.primary,
                                }}
                                textStyle={{ bottom: 10, fontSize: 16 }}
                                style={{ marginTop: 20, bottom: 10, left: 20 }}
                                onPress={() => {
                                    handleGetTypeMdf()
                                }}
                                colorspin={Colors.background}
                                sizespin={25}
                                label="ثبت"

                            />





                        </View>





                    }






                    {State.Active == 1 ?
                        <SafeAreaView>


                            <View style={{ width: "100%", height: 60, flexDirection: "row", }}>

                                <TouchableOpacity

                                    onLongPress={() => setState({ ...State, showModal: true })}
                                    style={styles.navartop}>

                                    <Ionicons onPress={() => setwidth_one("1")} name={width_one !== "1" ? "square-outline" : 'checkbox'} size={25} color={width_one !== "1" ? Colors.secondText3 : Colors.yellowlight} />



                                    <Text style={styles.textbox}>نوار</Text>
                                </TouchableOpacity>

                                <View style={styles.farsitop}>

                                    <Ionicons onPress={() => setwidth_one("2")} name={width_one !== "2" ? "square-outline" : 'checkbox'}
                                        size={25} color={width_one !== "2" ? Colors.secondText3 : Colors.yellowlight} />

                                    <Text style={styles.textbox}>فارسی</Text>
                                </View>


                                <View style={styles.shiartop}>

                                    <Ionicons onPress={() => setwidth_one("3")} name={width_one !== "3" ? "square-outline" : 'checkbox'}
                                        size={25} color={width_one !== "3" ? Colors.secondText3 : Colors.yellowlight} />

                                    <Text style={styles.textbox}>شیار</Text>
                                </View>

                            </View>



                            <View style={{ width: "100%", height: 300, flexDirection: "row" }}>
                                <View style={styles.viewR}>

                                    <TouchableOpacity onLongPress={() => setState({ ...State, showModal: true })} style={styles.navar_right}>

                                        <Ionicons onPress={() => setlength_one("1")} name={length_one !== "1" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_one !== "1" ? Colors.secondText3 : Colors.yellowlight} />


                                        <Text style={styles.textbox}>نوار</Text>
                                    </TouchableOpacity>

                                    {Platform.OS == "web" ?

                                        <INPUWEB

                                            stylelabel={{ width: "35%" }}
                                            label="طول"
                                            type="text"
                                            id="message"
                                            name="message"
                                            onChange={(event) => setHeight(event.target.value)}
                                            value={Height}

                                        />

                                        :


                                        <INPU
                                            label="طول"
                                            styleview={{ width: "80%", alignSelf: "auto", marginTop: 80, }}
                                            stylelabel={{ width: 35, top: Platform.OS == "web" ? -9 : -13, left: 25 }}
                                            keyboardType="number-pad"
                                            value={Height}
                                            onChangeText={(task1) => setHeight(task1)}
                                            styleinput={Platform.OS === "web" && { outlineColor: Colors.primary, }}

                                        />
                                    }
                                    <View style={styles.farsi_right}>

                                        <Ionicons onPress={() => setlength_one("2")} name={length_one !== "2" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_one !== "2" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={styles.textbox}>فارسی</Text>
                                    </View>



                                    <View style={styles.shiar_right}>
                                        <Ionicons onPress={() => setlength_one("3")} name={length_one !== "3" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_one !== "3" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={styles.textbox}>شیار</Text>
                                    </View>

                                </View>



                                <View style={styles.viewimage}>

                                    {task.status == "false" ?
                                        <ImageBackground


                                            source={{ uri: Forming.imagemdf }}
                                            style={{ width: "100%", height: "100%" }} alt="image" >
                                            <Btn
                                                label="انتخاب ورق"
                                                style={{ width: 100, marginLeft: "28%", marginTop: 100, }}
                                                touchableStyle={{ borderRadius: 20, backgroundColor: Colors.yellowlight }}
                                                textStyle={{ bottom: 10 }}
                                                onPress={() => setState({ ...State, showModal1: true })}
                                            />
                                            <TouchableOpacity onPress={() => setup_rotation(!up_rotation,)} style={styles.touch_rotate}>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: up_rotation == true ? Colors.primary : Colors.background, }}>چرخش</Text>
                                                {/* <Ionicons name='arrow-back-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} />
                                                <Ionicons name='arrow-forward-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} style={{ position: "absolute", right: 0 }} /> */}
                                            </TouchableOpacity>
                                            {/* <TouchableOpacity onPress={() => setForming({ ...Forming, right_rotation: true, up_rotation: false })} style={styles.touch_rotate}>

                                                <Ionicons name='arrow-back-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} />
                                                <Ionicons name='arrow-forward-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} style={{ position: "absolute", right: 0 }} />
                                            </TouchableOpacity> */}
                                            {/* <TouchableOpacity onPress={() => setForming({ ...Forming, right_rotation: false, up_rotation: true })} style={styles.touch_up}>

                                                <Ionicons name='arrow-up-outline' size={30} color={Forming.up_rotation == false ? Colors.RGB2 : Colors.primary} />
                                                <Ionicons name='arrow-down-outline' size={30} color={Forming.up_rotation == false ? Colors.RGB2 : Colors.primary} style={{ position: "absolute", bottom: 0 }} />
                                            </TouchableOpacity> */}
                                        </ImageBackground>
                                        :
                                        <SafeAreaView style={{ top: 180 }}>
                                            <TouchableOpacity onPress={() => setup_rotation(!up_rotation,)} style={styles.touch_rotate}>
                                                <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: up_rotation == true ? Colors.primary : Colors.background, }}>چرخش</Text>
                                                {/* <Ionicons name='arrow-back-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} />
                                                <Ionicons name='arrow-forward-outline' size={30} color={Forming.up_rotation == false ? Colors.primary : Colors.RGB2} style={{ position: "absolute", right: 0 }} /> */}
                                            </TouchableOpacity>
                                            {/* <TouchableOpacity onPress={() => setForming({ ...Forming, right_rotation: false, up_rotation: !Forming.up_rotation })} style={styles.touch_up}>

                                                <Ionicons name='arrow-up-outline' size={30} color={Forming.up_rotation == false ? Colors.RGB2 : Colors.primary} />
                                                <Ionicons name='arrow-down-outline' size={30} color={Forming.up_rotation == false ? Colors.RGB2 : Colors.primary} style={{ position: "absolute", bottom: 0 }} />
                                            </TouchableOpacity> */}
                                        </SafeAreaView>
                                    }

                                </View>





                                <View style={{ width: "25%", height: 300, position: "absolute", left: 0 }}>
                                    <TouchableOpacity onLongPress={() => setState({ ...State, showModal: true })} style={styles.navar_left}>

                                        <Ionicons onPress={() => setlength_two("1")} name={length_two !== "1" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_two !== "1" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={styles.textbox}>نوار</Text>
                                    </TouchableOpacity>

                                    <View style={styles.farsi_left}>

                                        <Ionicons onPress={() => setlength_two("2")} name={length_two !== "2" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_two !== "2" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={styles.textbox}>فارسی</Text>
                                    </View>



                                    <View style={styles.shiar_left}>
                                        <Ionicons onPress={() => setlength_two("3")} name={length_two !== "3" ? "square-outline" : 'checkbox'}
                                            size={25} color={length_two !== "3" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={styles.textbox}>شیار</Text>
                                    </View>

                                </View>

                            </View>




                            <View style={{ width: "100%", height: 60, flexDirection: "row", }}>

                                <TouchableOpacity onLongPress={() => setState({ ...State, showModal: true })} style={styles.navar_down}>
                                    <Ionicons onPress={() => setwidth_two("1")} name={width_two !== "1" ? "square-outline" : 'checkbox'}
                                        size={25} color={width_two !== "1" ? Colors.secondText3 : Colors.yellowlight} />


                                    <Text style={styles.textbox}>نوار</Text>
                                </TouchableOpacity>


                                {Platform.OS == "web" ?
                                    <INPUWEB
                                        style={{ width: "18%", alignSelf: "auto", marginTop: 12, position: "absolute", right: "32%" }}
                                        stylelabel={{ zIndex: 2, width: "10%", top: "5%", marginLeft: "23%" }}
                                        label="عرض"
                                        type="text"
                                        id="message"
                                        name="message"
                                        onChange={(event) => setWidth(event.target.value)}
                                        value={Width}

                                    />
                                    :


                                    <INPU
                                        label="عرض"
                                        styleview={{ width: "20%", alignSelf: "auto", marginTop: 12, position: "absolute", right: "32%" }}
                                        stylelabel={{ width: 37, top: Platform.OS == "web" ? -9 : -13, right: 20 }}
                                        keyboardType="number-pad"
                                        value={Width}
                                        onChangeText={(task) => setWidth(task)}
                                        styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                                    />}

                                <View style={styles.farsi_down}>
                                    <Ionicons onPress={() => setwidth_two("2")} name={width_two !== "2" ? "square-outline" : 'checkbox'}
                                        size={25} color={width_two !== "2" ? Colors.secondText3 : Colors.yellowlight} />

                                    <Text style={styles.textbox}>فارسی</Text>
                                </View>


                                <View style={styles.shiar_down}>
                                    <Ionicons onPress={() => setwidth_two("3")} name={width_two !== "3" ? "square-outline" : 'checkbox'}
                                        size={25} color={width_two !== "3" ? Colors.secondText3 : Colors.yellowlight} />

                                    <Text style={styles.textbox}>شیار</Text>
                                </View>

                            </View>



                            <View style={{ width: "100%", height: 70, marginTop: 40, alignItems: "center", justifyContent: 'center' }}>
                                <View style={{ flexDirection: "row", width: "90%", height: 50, borderWidth: 1, borderColor: Colors.secondText, borderRadius: 5, }}>
                                    <TouchableOpacity onPress={() => decrementCounter()} style={{ alignItems: "center", justifyContent: "center", width: "20%", height: 48, backgroundColor: Colors.primary, borderRadius: 4 }}>
                                        <Ionicons name='remove-outline' size={35} color={Colors.background} />
                                    </TouchableOpacity>






                                    <View style={{ width: "60%", height: 48, backgroundColor: Colors.background1, alignItems: "center", justifyContent: "center" }}>
                                        <View style={{ width: "30%", height: 20, backgroundColor: Colors.background1, alignItems: "center", position: "absolute", bottom: "84%", left: "35%" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3, }}>تعداد تکه</Text>
                                        </View>
                                        <Text style={{ fontFamily: "Montserrat", fontSize: 22, color: Colors.black }}>{counter}</Text>

                                    </View>


                                    <TouchableOpacity onPress={() => incrementCounter()} style={{ alignItems: "center", justifyContent: "center", width: "20%", height: 48, backgroundColor: Colors.primary, position: "absolute", right: 0, borderRadius: 4 }}>
                                        <Ionicons name='add' size={35} color={Colors.background} />
                                    </TouchableOpacity>
                                </View>


                            </View>



                            <INPU
                                label="توضیحات"
                                multiline
                                styleinput={{ height: 100 }}
                                styleview={{ height: 100, marginBottom: "20%", marginTop: 20 }}
                                stylelabel={{ width: 70, top: Platform.OS == "web" ? -9 : -15 }}
                                keyboardType="default"
                                value={description}
                                onChangeText={(text) => setdescription(text)}


                            //styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}

                            />




                        </SafeAreaView>
                        :
                        <View></View>
                    }






                    <AwesomeAlert
                        show={ERROR}
                        showProgress={false}
                        title={Massage == "با موفقیت ثبت شد" ? "" : "اخطار"}
                        message={Massage}
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}
                        showCancelButton={Massage == "با موفقیت ثبت شد" ? true : false}
                        showConfirmButton={true}
                        cancelText="افزودن قطعه جدید"
                        confirmText="تکمیل سفارش"
                        confirmButtonColor={Colors.success}
                        onCancelPressed={() => {
                            if (Massage == "با موفقیت ثبت شد") {
                                setError(false);
                                setCounter(1)
                                setdescription("ندارم")
                                setWidth("")
                                setHeight("")
                                setwidth_two("0")
                                setwidth_one("0")
                                setlength_one("0")
                                setlength_two("0")
                                setup_rotation(false)
                                setForming({
                                    Radio1: "color",
                                    Radio2: "1",
                                    Radio3: "single",


                                })




                            } else {
                                setError(false)
                            }
                        }}
                        onConfirmPressed={() => {
                            if (Massage == "با موفقیت ثبت شد") {
                                setError(false);
                                setCounter(1)
                                setdescription("ندارم")
                                setWidth("")
                                setHeight("")
                                setwidth_two("0")
                                setwidth_one("0")
                                setlength_one("0")
                                setlength_two("0")
                                setup_rotation(false)
                                props.navigation.navigate("list", {
                                    ids: props.route.params.orderid ? props.route.params.orderid : IMAGING ? IMAGING : ""
                                })


                                setForming({
                                    Radio1: "color",
                                    Radio2: "1",
                                    Radio3: "single",




                                })




                            } else {
                                setError(false)
                            }

                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                        confirmButtonStyle={{ width: Massage == "با موفقیت ثبت شد" ? "42%" : "80%", height: 40, alignItems: "center" }}
                        cancelButtonStyle={{ width: "53%", height: 40, backgroundColor: Colors.primary, alignItems: "center" }}
                        cancelButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                    />


                    <AwesomeAlert

                        show={ERRORing}
                        showProgress={false}
                        title={"اخطار"}
                        message={"لطفا اطلاعات طول و عرض راکامل کنید.مقدار طول نباید از عرض بیشتر باشد."}
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}

                        showConfirmButton={true}
                        confirmText="باشه"
                        confirmButtonColor={Colors.success}

                        onConfirmPressed={() => {
                            setERRORing(false)
                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 18, color: "red" }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 15 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13, marginTop: Platform.OS == "web" ? 5 : 0 }}
                        confirmButtonStyle={{ width: "40%", height: 40, alignItems: "center" }}

                    />




                </ScrollView>






                {State.Active == 1 ?
                    <View style={styles.viewfooter}>
                        <Btn
                            label="تایید و ادامه"
                            style={{ width: "100%", position: "absolute", left: "5%", bottom: 0 }}
                            textStyle={{ bottom: 10 }}
                            colorspin={Colors.background}
                            sizespin={25}
                            loading={State.isLoading1}
                            onPress={() => {
                                if (props.route.params.Sliceid) {
                                    sendEDITFORMHandler()

                                } else {
                                    sendFORMHandler()

                                }



                            }}
                        />

                    </View>
                    :
                    <View></View>
                }




            </View>
        </NativeBaseProvider>

    )
        : (
            <NativeBaseProvider>
                <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                    <ActivityIndicator
                        animating={State.isLoading} size={30} color={Colors.primary} />

                    <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
                </View>
            </NativeBaseProvider>
        )
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background1,
        position: Platform.OS == "web" ? "fixed" : "relative"


    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    viewfooter: {
        width: "100%",
        height: 60,
        backgroundColor: Colors.background,
        justifyContent: "center",
        flexDirection: "row"



    },
    texttouch: {
        fontFamily: "Montserrat",
        fontSize: 12,
        color: Colors.secondText3,

    },
    touch: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        height: 180,
        backgroundColor: Colors.background1,
        marginTop: 10,
        marginBottom: 10,
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3

    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "16%" : "36%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 140,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top: Platform.OS == "web" ? "14%" : "33%"
    },
    texttitle: {
        fontFamily: "MontserratBold",
        fontSize: 15,
        color: Colors.background,
        padding: "5%"
    },
    textmodal: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: Colors.black,
        position: "absolute",
        right: "5%",
        top: "5%"
    },

    textbox: {
        fontFamily: "Montserrat",
        fontSize: 12,
        color: Colors.black,

    },
    navartop: {
        width: "20%",
        height: 60,
        position: "absolute",
        right: "16%", flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    farsitop: {
        width: "20%",
        height: 60,
        position: "absolute",
        right: "40%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    shiartop: {
        width: "20%",
        height: 60,
        position: "absolute",
        left: "16%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    viewR: {
        width: "25%",
        height: 300,
        position: "absolute",
        right: 0,
        flexDirection: "column"
    },
    navar_right: {
        width: "100%",
        height: 60,
        position: "absolute",
        top: 0,
        right: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    farsi_right: {
        width: "100%",
        height: 60,
        position: "absolute",
        top: "50%",
        right: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    shiar_right: {
        width: "100%",
        height: 60,
        position: "absolute",
        bottom: 0,
        right: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    viewimage: {
        width: "50%",
        height: 300,
        borderRadius: 5,
        position: "absolute",
        right: "25%",
        borderWidth: 2,
        borderColor: Colors.yellowlight,
        borderStyle: 'dashed'
    },
    touch_rotate: {
        flexDirection: "row",
        width: 80,
        height: 50,
        backgroundColor: Colors.yellowlight,
        borderRadius: 5,
        alignItems: "center",
        position: "absolute",
        bottom: 8,
        right: "30%",
        justifyContent: "center"
    },
    touch_up: {
        flexDirection: "column",
        width: 30,
        height: 70,
        backgroundColor: Colors.yellowlight,
        borderRadius: 5,
        alignItems: "center",
        position: "absolute",
        bottom: 8,
        right: "70%"
    },
    navar_left: {
        width: "100%",
        height: 60,
        position: "absolute",
        top: 0,
        left: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    farsi_left: {
        width: "100%",
        height: 60,
        position: "absolute",
        top: "40%",
        left: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    shiar_left: {
        width: "100%",
        height: 60,
        position: "absolute",
        bottom: 0,
        left: 20,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    navar_down: {
        width: "20%",
        height: 60,
        position: "absolute",
        right: "16%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    farsi_down: {
        width: "20%",
        height: 60,
        position: "absolute",

        right: "50%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    shiar_down: {
        width: "20%",
        height: 60,
        position: "absolute",
        left: "16%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },


})




export default Form